import { DISCLAIMERS_REQUEST } from "./constants";

export const fetchDisclaimers = () => ({
  type: DISCLAIMERS_REQUEST,
});
